import React, { Component } from "react";
import Button from "@material-ui/core/Button";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import { Link } from "react-router-dom";
import Grid from "@material-ui/core/Grid";
import Typography from "@material-ui/core/Typography";
import Container from "@material-ui/core/Container";
import { withStyles } from "@material-ui/core";
import { Cookies } from "react-cookie";
import { Alert, AlertTitle } from "@material-ui/lab";
import { Redirect } from "react-router-dom";
import Paper from "@material-ui/core/Paper";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableContainer from "@material-ui/core/TableContainer";
import TableHead from "@material-ui/core/TableHead";
import TablePagination from "@material-ui/core/TablePagination";
import TableRow from "@material-ui/core/TableRow";
import JDate from "jalali-date";
import Switch from "@material-ui/core/Switch";
import Snackbar from "@material-ui/core/Snackbar";
import * as constants from "../constants";
import Divider from "@material-ui/core/Divider";
import TableSortLabel from "@material-ui/core/TableSortLabel";
import Moment from "moment";
import NumberFormat from "react-number-format";
import HighlightOffIcon from "@material-ui/icons/HighlightOff";

import Collapse from "@material-ui/core/Collapse";
import Avatar from "@material-ui/core/Avatar";

import "react-modern-calendar-datepicker/lib/DatePicker.css";
import Calendar from "react-modern-calendar-datepicker";
import OutlinedInput from "@material-ui/core/OutlinedInput";
import IconButton from "@material-ui/core/IconButton";
import InputAdornment from "@material-ui/core/InputAdornment";
import FloatingLabelInput from "./FloatingLabelInput";
import Fab from "@material-ui/core/Fab";
import VoiceOverOffIcon from "@material-ui/icons/VoiceOverOff";
import RecordVoiceOverIcon from "@material-ui/icons/RecordVoiceOver";
import CloseIcon from "@material-ui/icons/Close";
import CheckIcon from "@material-ui/icons/Check";
import Select from "react-select";
import { $post } from "./../func";
import ImageUploader from "react-images-upload";
import LinearProgress from "@material-ui/core/LinearProgress";

import ReactHTMLTableToExcel from "react-html-table-to-excel";
import { Lightbox } from "react-modal-image";
import KeyboardArrowUpIcon from "@material-ui/icons/KeyboardArrowUp";
import KeyboardArrowDownIcon from "@material-ui/icons/KeyboardArrowDown";
import Box from "@material-ui/core/Box";
import { makeStyles } from "@material-ui/core/styles";
import Checkbox from "@material-ui/core/Checkbox";

const styles = (theme) => ({
  paperrtl: {
    marginTop: theme.spacing(0),
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
  },
  paper: {
    display: "flex",
    flexWrap: "wrap",
    "& > *": {
      margin: theme.spacing(1),
      width: theme.spacing(20),
    },
  },
  root: {
    width: "100%",
    margin: "15px",
    padding: "8px",
    direction: "rtl",
  },
  container: {
    maxHeight: 400,
  },
  large: {
    width: theme.spacing(10),
    height: theme.spacing(10),
  },
  small: {
    width: theme.spacing(6),
    height: theme.spacing(6),
  },
});

const useRowStyles = makeStyles({
  root: {
    "& > *": {
      borderBottom: "unset",
    },
  },
});

class ChangeReportInstalmentDificitOrganSend extends Component {
  cookies = new Cookies();
  temp333;
  constructor(props) {
    super(props);
    this.state = {
      redirect: false,
      errstr: "",
      errstatus: false,
      okstatus: false,
      requestinfos: [],
      requestinfofilter: [],
      rowsPerPage: 10,
      page: 0,

      orderBy: "instalment_check_id",
      order: "desc",
      snackstr: "",
      showSnack: false,
      snackMode: "success",

      instalmentDateEnd: "",
      instalmentDateStart: "",
      refundUserMaxAmount: "",
      refundUserMinAmount: "",
      checkDatePass: "",
      checkDocPass: "",
      sumAll: [],
      request_financial_doc_peydate: "",
      request_financial_doc_code: "",

      requestIdFilter: "",

      urlToLargeImageFile: "",
      urlToHugeImageFile: "",
      descImageFile: "",
      openImageBox: false,
      selectedConfirmOrgan: { value: null },
    };
  }

  setSelectedDayStart = (event) => {
    this.setState({ request_financial_doc_peydate: event }, () => {});
  };

  clearDeyStart = (event) => {
    this.setState({ request_financial_doc_peydate: "" }, () => {});
  };

  setSelectedDateEnd = (event) => {
    this.setState({ instalmentDateEnd: event }, () => {});
  };

  clearDateEnd = (event) => {
    this.setState({ instalmentDateEnd: "" }, () => {});
  };

  setSelectedDateStart = (event) => {
    this.setState({ instalmentDateStart: event }, () => {});
  };

  clearDeyMin = (event) => {
    this.setState({ instalmentDateStart: "" }, () => {});
  };

  clearDatePass = (event) => {
    this.setState({ checkDatePass: "" }, () => {});
  };

  handleChangeFinancialDocCode = (event) => {
    this.setState({ request_financial_doc_code: event.target.value });
  };

  handleChangeMaxAmount = (event) => {
    this.setState({ refundUserMaxAmount: event }, () => {
      this.filterList();
    });
  };

  handleChangeMinAmount = (event) => {
    this.setState({ refundUserMinAmount: event }, () => {
      this.filterList();
    });
  };

  handleClickcloseTasckBar = (event) => {
    this.setState({ showSnack: false });
  };

  handleChangeFilterRequestId = (event) => {
    this.setState({ requestIdFilter: event.target.value }, () => {
      this.filterList();
    });
  };

  // -------------------------------------------------------------------------------------------------------
  
 async saveFinancialDocCode()  {
    const {
      request_financial_doc_peydate,
      request_financial_doc_code,
      financialDoc,
    } = this.state;
    if (
      request_financial_doc_code !== "" &&
      request_financial_doc_code !== null &&
      request_financial_doc_peydate !== "" &&
      request_financial_doc_peydate !== null
    ) {
      this.props.props.props.dispatch({
        type: "WAITSHOW",
      });

      var self = this;
      const response = await $post(`financialpaying?command=pey_doc&request_financial_doc_id=${financialDoc.request_financial_doc_id}&
      request_financial_doc_peydate=${Moment(
        JDate.toGregorian(
          request_financial_doc_peydate.year,
          request_financial_doc_peydate.month,
          request_financial_doc_peydate.day
        )
      ).format("YYYY-MM-DD h:mm:ss")}&request_financial_doc_code=${request_financial_doc_code}
      `, {
        Authorization: this.cookies.get("employee_token_str"),
      });

      const arr = response.data;
      // var xhttp = new XMLHttpRequest();
      // xhttp.onreadystatechange = function () {
        if (response.status == 200) {
          // var arr = JSON.parse(this.responseText);
          // console.log(arr);
          if (arr.result === "ok") {
            self.setState({
              snackstr: arr.desc,
              showSnack: true,
              snackMode: "success",
            });
            
            self.getFinancialDocPaing();
            self.newFinancialDoc();
          } else if (arr.result === "error") {
            self.setState({
              snackstr: arr.desc,
              showSnack: true,
              snackMode: "error",
            });
          }
          self.props.props.props.dispatch({
            type: "WITEHIDE",
          });
        }
   
      // var fd = new FormData();
      // fd.append("command", "pey_doc");
      // fd.append(
      //   "request_financial_doc_id",
      //   financialDoc.request_financial_doc_id
      // );
      // fd.append(
      //   "request_financial_doc_peydate",
      //   Moment(
      //     JDate.toGregorian(
      //       request_financial_doc_peydate.year,
      //       request_financial_doc_peydate.month,
      //       request_financial_doc_peydate.day
      //     )
      //   ).format("YYYY-MM-DD h:mm:ss")
      // );
      // fd.append("request_financial_doc_code", request_financial_doc_code);

      // xhttp.open("POST", `${constants.BASE_URL}/financialpaying`);
      // xhttp.setRequestHeader(
      //   "Authorization",
      //   this.cookies.get("employee_token_str")
      // );
      // xhttp.send(fd);
    } else {
      this.setState({
        snackstr: "لطفا مشخصات مدت زمان بیمه نامه  را وارد نمایید",
        showSnack: true,
        snackMode: "error",
      });
    }
  };

  // ----------------------------------------------------------------------------------------
  async componentDidMount() {
    if (this.cookies.get("employee_token_str")) {
      this.props.props.props.dispatch({
        type: "WAITSHOW",
      });
      const response = await $post(`employeelogin?command=checkemployeelogin`, {
        Authorization: this.cookies.get("employee_token_str"),
      });

      const arr = response.data;
      var self = this;
      // var xhttp = new XMLHttpRequest()
      // xhttp.onreadystatechange = function() {
      if (response.status == 200) {
        // var arr = JSON.parse(this.responseText)
        if (arr.result === "ok") {
          self.getOptionOrgan();
        } else if (arr.result === "error") {
          self.setState({ redirect: true });
        }
        self.props.props.props.dispatch({
          type: "WITEHIDE",
        });
      }

      // var fd = new FormData()
      // fd.append("command", "checkemployeelogin")

      // xhttp.open("POST", `${constants.BASE_URL}/employeelogin`)
      // xhttp.setRequestHeader("Authorization", this.cookies.get("employee_token_str"))
      // xhttp.send(fd)
    } else {
      this.setState({ redirect: true });
    }
  }

  // --------------------------------------------------------------------------------------
  async getOptionConfirmOrgan(organ_id) {
    const response = await $post(
      `organ?command=get_clearing_confirms&organ_id=${organ_id}`,
      {
        Authorization: this.cookies.get("employee_token_str"),
      }
    );
    console.log(response, "response response ");
    const arr = response.data;
    var self = this;
    // var xhttp = new XMLHttpRequest()
    // xhttp.onreadystatechange = function() {
    if (response.status === 200 ) {
      // var arr = JSON.parse(this.responseText)
      console.log(arr);
      if (arr.result === "ok") {
        var Organ = [{ value: 0, label: "پیش نویس جدید" }];
        for (var k = 0; k < arr.data.length; k++) {
          var datetemp =
            new JDate(
              new Date(
                parseInt(
                  Moment(
                    arr.data[k].organ_confirm_sms_recive_date,
                    "YYYY-M-D HH:mm:ss"
                  ).format("x")
                )
              )
            ).format("YYYY/MM/DD") +
            " " +
            Moment(
              arr.data[k].organ_confirm_sms_recive_date,
              "YYYY-M-D HH:mm:ss"
            ).format("HH:mm:ss");
          Organ.push({
            value: arr.data[k].organ_confirm_id,
            label: datetemp,
            sms_confirm_date_start: arr.data[k].sms_confirm_date_start,
            sms_confirm_date_end: arr.data[k].sms_confirm_date_end,
          });
        }
        self.setState(
          { optionConfirmOrgan: Organ, selectedConfirmOrgan: Organ[0] },
          () => {}
        );
      } else if (arr.result === "error") {
        self.setState({
          snackstr: arr.desc,
          showSnack: true,
          snackMode: "error",
        });
      }
    }

    // var fd = new FormData()
    // fd.append("command", "get_clearing_confirms")
    // fd.append("organ_id", organ_id)
    // xhttp.open("POST", `${constants.BASE_URL}/organ`)
    // xhttp.setRequestHeader("Authorization", this.cookies.get("employee_token_str"))
    // xhttp.send(fd)
  }

  // ----------------------------------------------------------------------------------------------------------------------
  async getOptionOrgan() {
    const response = await $post(`organ?command=get_organ`, {
      Authorization: this.cookies.get("employee_token_str"),
    });
    
    const arr = response.data;
    var self = this;
    // var xhttp = new XMLHttpRequest()
    // xhttp.onreadystatechange = function() {
    if (response.status === 200) {
      // var arr = JSON.parse(this.responseText)
      console.log(arr);
      if (arr.result === "ok") {
        var Organ = [];
        for (var k = 0; k < arr.data.length; k++) {
          Organ.push({
            value: arr.data[k].organ_id,
            label: arr.data[k].organ_name,
          });
        }
        self.setState({ optionSelectOrgan: Organ }, () => {});
      } else if (arr.result === "error") {
        self.setState({
          snackstr: arr.desc,
          showSnack: true,
          snackMode: "error",
        });
      }
    }

    // var fd = new FormData()
    // fd.append("command", "get_organ")
    // xhttp.open("POST", `${constants.BASE_URL}/organ`)
    // xhttp.setRequestHeader("Authorization", this.cookies.get("employee_token_str"))
    // xhttp.send(fd)
  }

  datareset = (x) => {
    for (let i = 0; i < x.length; i++) {
      x[i].checked = false;
      for (let j = 0; j < x[i].request_check_notpass.length; j++) {
        x[i].request_check_notpass[j].checked = false;
      }
    }
  };

  sumselectedcheckbox = () => {
    const { requestinfofilter } = this.state;
    const datacheck = [];
    // eslint-disable-next-line no-plusplus
    for (let i = 0; i < requestinfofilter.length; i++) {
      // eslint-disable-next-line no-plusplus
      for (
        let j = 0;
        j < requestinfofilter[i].request_check_notpass.length;
        j++
      ) {
        if (requestinfofilter[i].request_check_notpass[j].checked) {
          datacheck.push(
            // eslint-disable-next-line radix
            parseInt(
              requestinfofilter[i].request_check_notpass[j]
                .instalment_check_amount
            )
          );
        }
      }
    }
    this.setState({ sumAll: datacheck }, () => {});
  };

  handleChangeCheckbox = (event, row) => {
    console.log(event);
    const { requestinfofilter } = this.state;
    var arraytemp = requestinfofilter;
    var i;
    for (i = 0; i < arraytemp.length; i++) {
      if (arraytemp[i].user_id === row.user_id) {
        arraytemp[i].checked = event.target.checked;
        if (event.target.checked) {
          for (let j = 0; j < arraytemp[i].request_check_notpass.length; j++) {
            arraytemp[i].request_check_notpass[j].checked = true;
          }
        } else {
          for (let j = 0; j < arraytemp[i].request_check_notpass.length; j++) {
            arraytemp[i].request_check_notpass[j].checked = false;
          }
        }
      }
    }

    this.setState({ requestinfofilter: arraytemp }, () => {
      this.sumselectedcheckbox();
    });
  };

  handleChangeCheckbox2 = (event, row, instalment_check_id) => {
    console.log(event);
    const { requestinfofilter } = this.state;
    var arraytemp = requestinfofilter;
    var i;
    for (i = 0; i < arraytemp.length; i++) {
      if (arraytemp[i].user_id === row.user_id) {
        var temp = true;
        for (let j = 0; j < arraytemp[i].request_check_notpass.length; j++) {
          if (
            arraytemp[i].request_check_notpass[j].instalment_check_id ===
            instalment_check_id
          ) {
            arraytemp[i].request_check_notpass[j].checked =
              event.target.checked;
          }
          if (arraytemp[i].request_check_notpass[j].checked === false) {
            temp = false;
          }
        }
        arraytemp[i].checked = temp;
      }
    }

    this.setState({ requestinfofilter: arraytemp }, () => {
      this.sumselectedcheckbox();
    });
  };
  getInstallmentTempOrgan() {
    const { selectedConfirmOrgan, requestinfofilter } = this.state;
    this.props.props.props.dispatch({
      type: "WAITSHOW",
    });
    var self = this;
    var xhttp = new XMLHttpRequest();
    xhttp.onreadystatechange = function () {
      if (this.readyState === 4 && this.status === 200) {
        var arr = JSON.parse(this.responseText);
        console.log(arr);
        if (arr.result === "ok") {
          //**********************************************************************
          var arraytemp = requestinfofilter;
          for (let j = 0; j < arraytemp.length; j++) {
            var temp2 = true;
            for (
              let k = 0;
              k < arraytemp[j].request_check_notpass.length;
              k++
            ) {
              var temp = false;
              for (let i = 0; i < arr.data.length; i++) {
                if (
                  arraytemp[j].request_check_notpass[k].instalment_check_id ===
                  arr.data[i].instalment_check_organ_temp_check_id
                ) {
                  temp = true;
                }
              }
              if (temp === true) {
                arraytemp[j].request_check_notpass[k].checked = temp;
              } else {
                arraytemp[j].request_check_notpass[k].checked = temp;
                temp2 = false;
              }
            }

            arraytemp[j].checked = temp2;
          }

          self.setState({ requestinfofilter: arraytemp }, () => {
            self.sumselectedcheckbox();
          });
          //**********************************************************************
        } else if (arr.result === "error") {
        }
        self.props.props.props.dispatch({
          type: "WITEHIDE",
        });
      }
    };
    var fd = new FormData();
    fd.append("command", "get_check_clearing_confirms");

    fd.append(
      "instalment_check_organ_temp_confirm_id",
      selectedConfirmOrgan.value
    );

    xhttp.open("POST", `${constants.BASE_URL}/reportinstallmentpay`);
    xhttp.setRequestHeader(
      "Authorization",
      this.cookies.get("employee_token_str")
    );
    xhttp.send(fd);
  }
  getFinancialDocPaing() {
    const {
      instalmentDateStart,
      instalmentDateEnd,
      selectedOrgan,
      selectedConfirmOrgan,
    } = this.state;
    this.props.props.props.dispatch({
      type: "WAITSHOW",
    });
    var self = this;
    var xhttp = new XMLHttpRequest();
    xhttp.onreadystatechange = function () {
      if (this.readyState === 4 && this.status === 200) {
        var arr = JSON.parse(this.responseText);
        console.log(arr);
        if (arr.result === "ok") {
          self.datareset(arr.data);
          self.setState(
            { requestinfos: arr.data, requestinfofilter: arr.data },
            () => {
              if (selectedConfirmOrgan.value !== 0) {
                self.getInstallmentTempOrgan();
              }
            }
          );

          var State2 = [{ value: "0", label: "همه رشته ها" }];
          var State3 = [{ value: "0", label: "همه وضعیت ها" }];
          for (var k = 0; k < arr.data.length; k++) {
            var toFind = arr.data[k].fieldinsurance_id;
            var filtered = State2.filter(function (el) {
              return el.value === toFind;
            });
            if (filtered.length === 0) {
              State2.push({
                value: arr.data[k].fieldinsurance_id,
                label: arr.data[k].request_fieldinsurance_fa,
              });
            }

            toFind = arr.data[k].request_last_state_id;
            filtered = State3.filter(function (el) {
              return el.value === toFind;
            });
            if (filtered.length === 0) {
              State3.push({
                value: arr.data[k].request_last_state_id,
                label: arr.data[k].request_last_state_name,
              });
            }
          }
        } else if (arr.result === "error") {
        }
        self.props.props.props.dispatch({
          type: "WITEHIDE",
        });
      }
    };
    var fd = new FormData();
    fd.append("command", "get_user_organ_installment");
    if (instalmentDateEnd === "") {
      fd.append("date_end", "");
    } else {
      fd.append(
        "date_end",
        Moment(
          JDate.toGregorian(
            instalmentDateEnd.year,
            instalmentDateEnd.month,
            instalmentDateEnd.day
          )
        ).format("YYYY-MM-DD h:mm:ss")
      );
    }
    if (instalmentDateStart === "") {
      fd.append("date_start", "");
    } else {
      fd.append(
        "date_start",
        Moment(
          JDate.toGregorian(
            instalmentDateStart.year,
            instalmentDateStart.month,
            instalmentDateStart.day
          )
        ).format("YYYY-MM-DD h:mm:ss")
      );
    }
    fd.append("organ_id", selectedOrgan.value);

    xhttp.open("POST", `${constants.BASE_URL}/reportinstallmentpay`);
    xhttp.setRequestHeader(
      "Authorization",
      this.cookies.get("employee_token_str")
    );
    xhttp.send(fd);
  }

  createConfirmOrfan() {
    const { instalmentDateStart, instalmentDateEnd } = this.state;
    this.props.props.props.dispatch({
      type: "WAITSHOW",
    });

    var self = this;
    var xhttp = new XMLHttpRequest();
    xhttp.onreadystatechange = function () {
      if (this.readyState === 4 && this.status === 200) {
        var arr = JSON.parse(this.responseText);
        console.log(arr);
        if (arr.result === "ok") {
          console.log(arr);
          self.createTempDoc(arr.data.organ_confirm_id);
        } else if (arr.result === "error") {
        }
        self.props.props.props.dispatch({
          type: "WITEHIDE",
        });
      }
    };
    var fd = new FormData();
    fd.append("command", "create_confirms_organ");
    if (instalmentDateEnd === "") {
      fd.append("sms_confirm_date_end", "");
    } else {
      fd.append(
        "sms_confirm_date_end",
        Moment(
          JDate.toGregorian(
            instalmentDateEnd.year,
            instalmentDateEnd.month,
            instalmentDateEnd.day
          )
        ).format("YYYY-MM-DD h:mm:ss")
      );
    }
    if (instalmentDateStart === "") {
      fd.append("sms_confirm_date_start", "");
    } else {
      fd.append(
        "sms_confirm_date_start",
        Moment(
          JDate.toGregorian(
            instalmentDateStart.year,
            instalmentDateStart.month,
            instalmentDateStart.day
          )
        ).format("YYYY-MM-DD h:mm:ss")
      );
    }

    xhttp.open("POST", `${constants.BASE_URL}/reportinstallmentpay`);
    xhttp.setRequestHeader(
      "Authorization",
      this.cookies.get("employee_token_str")
    );
    xhttp.send(fd);

    //*************************************************************
  }

  createTempDoc(organ_confirm_id) {
    const {
      requestinfofilter,
      instalmentDateStart,
      instalmentDateEnd,
      selectedOrgan,
      selectedConfirmOrgan,
    } = this.state;
    this.props.props.props.dispatch({
      type: "WAITSHOW",
    });
    for (let i = 0; i < requestinfofilter.length; i++) {
      for (
        let j = 0;
        j < requestinfofilter[i].request_check_notpass.length;
        j++
      ) {
        // eslint-disable-next-line no-await-in-loop,no-unused-vars
        if (requestinfofilter[i].request_check_notpass[j].checked === true) {
          //*************************************************************
          var self = this;
          var xhttp = new XMLHttpRequest();
          xhttp.onreadystatechange = function () {
            if (this.readyState === 4 && this.status === 200) {
              var arr = JSON.parse(this.responseText);
              console.log(arr);
              if (arr.result === "ok") {
                if (
                  i === requestinfofilter.length - 1 &&
                  j === requestinfofilter[i].request_check_notpass.length - 1
                ) {
                  self.getOptionConfirmOrgan(selectedOrgan.value);
                }
              } else if (arr.result === "error") {
              }
              self.props.props.props.dispatch({
                type: "WITEHIDE",
              });
            }
          };
          var fd = new FormData();
          fd.append("command", "add_organ_instalment_temp");
          fd.append(
            "instalment_check_organ_temp_check_id",
            requestinfofilter[i].request_check_notpass[j].instalment_check_id
          );
          fd.append("instalment_check_organ_temp_confirm_id", organ_confirm_id);

          xhttp.open("POST", `${constants.BASE_URL}/reportinstallmentpay`);
          xhttp.setRequestHeader(
            "Authorization",
            this.cookies.get("employee_token_str")
          );
          xhttp.send(fd);
          //*************************************************************
        }
      }
    }
  }

  handleConfirmOrgan = (selectedConfirmOrgan) => {
    if (selectedConfirmOrgan.value !== 0) {
      console.log(selectedConfirmOrgan);
      var jdate1 = "",
        jdate2 = "";
      if (selectedConfirmOrgan.sms_confirm_date_start !== "") {
        var varmoment1 = Moment(
          selectedConfirmOrgan.sms_confirm_date_start,
          "YYYY-M-D HH:mm:ss"
        );
        var date1 = new Date(parseInt(varmoment1.format("x")));
        jdate1 = new JDate(date1);
        jdate1 = {
          day: parseInt(jdate1.format("DD")),
          month: parseInt(jdate1.format("MM")),
          year: parseInt(jdate1.format("YYYY")),
        };
      }
      if (selectedConfirmOrgan.sms_confirm_date_end !== "") {
        var varmoment2 = Moment(
          selectedConfirmOrgan.sms_confirm_date_end,
          "YYYY-M-D HH:mm:ss"
        );
        var date2 = new Date(parseInt(varmoment2.format("x")));
        var jdate2 = new JDate(date2);
        jdate2 = {
          day: parseInt(jdate2.format("DD")),
          month: parseInt(jdate2.format("MM")),
          year: parseInt(jdate2.format("YYYY")),
        };
      }

      this.setState(
        {
          selectedConfirmOrgan: selectedConfirmOrgan,
          instalmentDateEnd: jdate2,
          instalmentDateStart: jdate1,
        },
        () => {
          this.getFinancialDocPaing();
        }
      );
    } else {
      this.setState(
        {
          selectedConfirmOrgan: selectedConfirmOrgan,
          instalmentDateEnd: "",
          instalmentDateStart: "",
          requestinfos: [],
          requestinfofilter: [],
          sumAll: [],
        },
        () => {}
      );
    }
  };

  handleStatusRequest = (selectedStatusRequest) => {
    this.setState({ selectedStatusRequest: selectedStatusRequest }, () => {
      this.filterList();
    });
  };

  handleSelectOrgan = (selectedOrgan) => {
    this.setState({ selectedOrgan: selectedOrgan }, () => {
      this.getOptionConfirmOrgan(selectedOrgan.value);
    });
  };

  filterList = () => {
    const {
      refundUserMaxAmount,
      requestIdFilter,
      refundUserMinAmount,
      requestinfos,
      selectedStatusRequest,
    } = this.state;

    var i, temparray, temparray2, instalment_check_date;
    temparray = requestinfos;
    temparray2 = [];
    for (i = 0; i < temparray.length; i++) {
      if (
        (temparray[i].request_last_state_id === selectedStatusRequest.value ||
          selectedStatusRequest.value === "0") &&
        ((requestIdFilter !== "" && temparray[i].user_id === requestIdFilter) ||
          requestIdFilter === "") &&
        (parseInt(refundUserMinAmount) <=
          parseInt(temparray[i].instalment_check_amount) ||
          refundUserMinAmount === "") &&
        (parseInt(refundUserMaxAmount) >
          parseInt(temparray[i].instalment_check_amount) ||
          refundUserMaxAmount === "")
      ) {
        temparray2.push(temparray[i]);
      }
    }
    this.setState({ requestinfofilter: temparray2 }, () => {});
  };

  createSortHandler = (field) => {
    if (this.state.orderBy === field) {
      if (this.state.order === "asc") {
        this.setState({ order: "desc" });
      } else {
        this.setState({ order: "asc" });
      }
    } else {
      this.setState({ orderBy: field, order: "asc" });
    }
    var arraytemp = [],
      i,
      j,
      temp,
      a,
      b;
    arraytemp = this.state.requestinfofilter;
    for (i = 0; i < arraytemp.length; i++) {
      for (j = 0; j < arraytemp.length - 1; j++) {
        a = arraytemp[j];
        b = arraytemp[j + 1];
        if (a[field] < b[field] && this.state.order === "asc") {
          temp = arraytemp[j];
          arraytemp[j] = arraytemp[j + 1];
          arraytemp[j + 1] = temp;
        } else if (a[field] > b[field] && this.state.order === "desc") {
          temp = arraytemp[j];
          arraytemp[j] = arraytemp[j + 1];
          arraytemp[j + 1] = temp;
        }
      }
    }
  };

  handleChangeRowsPerPage = (event) => {
    this.setState({ rowsPerPage: parseInt(event.target.value), page: 0 });
  };

  handleChangePage = (event, number) => {
    this.setState({ page: parseInt(number, 0) });
  };

  setImageModel = (image, largimage, desc) => {
    this.setState({
      urlToLargeImageFile: largimage,
      urlToHugeImageFile: image,
      descImageFile: desc,
      openImageBox: true,
    });
  };

  closeLightbox = () => {
    this.setState({
      openImageBox: false,
    });
  };

  renderCustomInputDateEnd = ({ ref }) => (
    <OutlinedInput
      readOnly
      ref={ref} // necessary
      placeholder="انتخاب تاریخ درخواست"
      style={{
        fontSize: "13px",
        direction: "ltr",
      }}
      value={
        this.state.instalmentDateEnd.year
          ? this.state.instalmentDateEnd.year +
            "/" +
            this.state.instalmentDateEnd.month +
            "/" +
            this.state.instalmentDateEnd.day
          : ""
      }
      className="my-custom-input-class" // a styling class
      endAdornment={
        <InputAdornment position="end">
          <IconButton onClick={this.clearDateEnd}>
            <HighlightOffIcon />
          </IconButton>
        </InputAdornment>
      }
    />
  );

  renderCustomInputDateStart = ({ ref }) => (
    <OutlinedInput
      readOnly
      ref={ref} // necessary
      placeholder="انتخاب تاریخ درخواست"
      style={{
        fontSize: "13px",
        direction: "ltr",
      }}
      value={
        this.state.instalmentDateStart.year
          ? this.state.instalmentDateStart.year +
            "/" +
            this.state.instalmentDateStart.month +
            "/" +
            this.state.instalmentDateStart.day
          : ""
      }
      className="my-custom-input-class" // a styling class
      endAdornment={
        <InputAdornment position="end">
          <IconButton onClick={this.clearDeyMin}>
            <HighlightOffIcon />
          </IconButton>
        </InputAdornment>
      }
    />
  );

  renderCustomInputDatePass = ({ ref }) => (
    <OutlinedInput
      readOnly
      ref={ref} // necessary
      placeholder="انتخاب تاریخ تعهد"
      style={{
        fontSize: "13px",
        direction: "ltr",
      }}
      value={
        this.state.checkDatePass.year
          ? this.state.checkDatePass.year +
            "/" +
            this.state.checkDatePass.month +
            "/" +
            this.state.checkDatePass.day
          : ""
      }
      className="my-custom-input-class" // a styling class
      endAdornment={
        <InputAdornment position="end">
          <IconButton onClick={this.clearDatePass}>
            <HighlightOffIcon />
          </IconButton>
        </InputAdornment>
      }
    />
  );
  renderCustomInputStart = ({ ref }) => (
    <OutlinedInput
      readOnly
      ref={ref} // necessary
      placeholder="انتخاب تاریخ سند"
      style={{
        fontSize: "13px",
        direction: "ltr",
      }}
      value={
        this.state.request_financial_doc_peydate.year
          ? this.state.request_financial_doc_peydate.year +
            "/" +
            this.state.request_financial_doc_peydate.month +
            "/" +
            this.state.request_financial_doc_peydate.day
          : ""
      }
      className="my-custom-input-class" // a styling class
      endAdornment={
        <InputAdornment position="end">
          <IconButton onClick={this.clearDeyStart}>
            <HighlightOffIcon />
          </IconButton>
        </InputAdornment>
      }
    />
  );

  render() {
    const { classes } = this.props;
    const {
      request_financial_doc_peydate,
      request_financial_doc_code,
      sumAll,
      requestIdFilter,
      instalmentDateEnd,
      instalmentDateStart,
      refundUserMaxAmount,
      refundUserMinAmount,
      optionConfirmOrgan,
      selectedConfirmOrgan,
      optionStatusRequest,
      selectedStatusRequest,
      optionSelectOrgan,
      selectedOrgan,
      snackMode,
      snackstr,
      showSnack,
      order,
      orderBy,
      okstatus,
      errstr,
      redirect,
      requestinfofilter,
      rowsPerPage,
      page,
      urlToHugeImageFile,
      descImageFile,
      urlToLargeImageFile,
    } = this.state;
    if (redirect) {
      return <Redirect to="/" />;
    } else {
      return (
        <div className={classes.paperrtl} dir="ltr">
          <Snackbar
            anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
            onClose={this.handleClickcloseTasckBar}
            open={showSnack}
            autoHideDuration={10000}
          >
            <Alert severity={snackMode}>{snackstr}</Alert>
          </Snackbar>
          <Grid container spacing={3}>
            <Grid item xs={12}>
              <Container component="main" maxWidth="lg">
                <Paper elevation={4} className={classes.root}>
                  <Grid container spacing={3}>
                    <Grid item xs={6} sm={3}>
                      <div>
                        <label className="on"> سازمان</label>
                        <Select
                          isSearchable={true}
                          className="adapter-txtsize"
                          placeholder={" سازمان"}
                          value={selectedOrgan}
                          onChange={this.handleSelectOrgan}
                          options={optionSelectOrgan}
                        />
                      </div>
                    </Grid>
                    <Grid item xs={6} sm={3}>
                      <div>
                        <label className="on">تاریخ ارسال پیش نویس</label>
                        <Select
                          isSearchable={true}
                          className="adapter-txtsize"
                          placeholder={"اریخ ارسال پیش نویس"}
                          value={selectedConfirmOrgan}
                          onChange={this.handleConfirmOrgan}
                          options={optionConfirmOrgan}
                        />
                      </div>
                    </Grid>
                    <Grid item xs={6} sm={3}>
                      <div style={{ width: "100%", textAlign: "center" }}>
                        <Typography variant="h7">
                          {"تاریخ تعهد از"}
                          <Calendar
                            renderInput={this.renderCustomInputDateStart} // render a custom input
                            value={instalmentDateStart}
                            onChange={this.setSelectedDateStart}
                            locale="fa"
                            shouldHighlightWeekends
                          />
                        </Typography>
                      </div>
                    </Grid>

                    <Grid item xs={6} sm={3}>
                      <div style={{ width: "100%", textAlign: "center" }}>
                        <Typography variant="h7">
                          {"تاریخ تعهد  تا"}
                          <Calendar
                            renderInput={this.renderCustomInputDateEnd} // render a custom input
                            value={instalmentDateEnd}
                            onChange={this.setSelectedDateEnd}
                            locale="fa"
                            shouldHighlightWeekends
                          />
                        </Typography>
                      </div>
                    </Grid>

                    <Grid item xs={6} sm={4}>
                      <Button
                        disabled={selectedConfirmOrgan.value !== 0}
                        variant="outlined"
                        color="primary"
                        onClick={() => {
                          this.getFinancialDocPaing();
                        }}
                      >
                        فیلتر
                      </Button>
                    </Grid>

                    <Grid item xs={6} sm={4}>
                      <Button
                        disabled={
                          selectedConfirmOrgan.value !== 0 ||
                          sumAll.length === 0
                        }
                        variant="outlined"
                        color="primary"
                        onClick={() => {
                          this.createConfirmOrfan();
                        }}
                      >
                        تولید پیشنویس برای سازمان
                      </Button>
                    </Grid>
                    <Grid item xs={12}>
                      <Divider />
                    </Grid>

                    <Grid item xs={6}>
                      <Typography align="center" variant="h7">
                        {"قیمت اسناد :"}
                        <NumberFormat
                          displayType={"text"}
                          value={sumAll.reduce((a, v) => (a += v), 0)}
                          thousandSeparator={true}
                          prefix={" ریال"}
                        />
                      </Typography>
                    </Grid>
                    <Grid item xs={6}>
                      <Typography align="center" variant="h7">
                        {"   تعداد اسناد انتخابی:"}
                        <NumberFormat
                          displayType={"text"}
                          value={sumAll.length}
                          thousandSeparator={true}
                          prefix={""}
                        />
                      </Typography>
                    </Grid>
                    <Grid item xs={12}>
                      {selectedConfirmOrgan.value !== 0 &&
                      sumAll.length !== 0 ? (
                        <Grid container spacing={3}>
                          <Grid item xs={6} sm={4}>
                            <div style={{ width: "100%", textAlign: "center" }}>
                              <Typography variant="h7">
                                {"تاریخ پرداخت  "}
                                <Calendar
                                  renderInput={this.renderCustomInputStart} // render a custom input
                                  value={request_financial_doc_peydate}
                                  onChange={this.setSelectedDayStart}
                                  locale="fa"
                                  shouldHighlightWeekends
                                />
                              </Typography>
                            </div>
                          </Grid>

                          <Grid item xs={6} sm={4}>
                            <FloatingLabelInput
                              placeholder="توضیحات پرداخت"
                              handleInputt={this.handleChangeFinancialDocCode}
                              value={request_financial_doc_code}
                            />
                          </Grid>

                          <Grid item xs={6} sm={4}>
                            <Button
                              variant="outlined"
                              color="primary"
                              onClick={(e) => {
                                this.saveFinancialDocCode();
                              }}
                            >
                              {"ثبت پرداخت سند"}
                            </Button>
                          </Grid>
                        </Grid>
                      ) : (
                        ""
                      )}
                    </Grid>

                    <Grid item xs={12}>
                      <Divider />
                    </Grid>

                    <Grid item xs={4}>
                      <FloatingLabelInput
                        type="currency"
                        placeholder="حداقل مبلغ"
                        handleInputt={this.handleChangeMinAmount}
                        value={refundUserMinAmount}
                      />
                    </Grid>
                    <Grid item xs={4}>
                      <FloatingLabelInput
                        type="currency"
                        placeholder="حداکثر مبلغ"
                        handleInputt={this.handleChangeMaxAmount}
                        value={refundUserMaxAmount}
                      />
                    </Grid>
                    <Grid sm={4}>
                      <FloatingLabelInput
                        placeholder="شماره سفارش"
                        value={requestIdFilter}
                        handleInputt={this.handleChangeFilterRequestId}
                      />
                    </Grid>

                    <Grid item xs={4}>
                      <div>
                        <label className="on">وضعیت درخواست</label>
                        <Select
                          isSearchable={true}
                          className="adapter-txtsize"
                          placeholder={"وضعیت درخواست"}
                          value={selectedStatusRequest}
                          onChange={this.handleStatusRequest}
                          options={optionStatusRequest}
                        />
                      </div>
                    </Grid>
                  </Grid>
                </Paper>
              </Container>
            </Grid>

            <Grid item xs={12}>
              <Container maxWidth="lg">
                <Paper className={classes.root}>
                  <ReactHTMLTableToExcel
                    id="test-table-xls-button"
                    className="download-table-xls-button"
                    table="table-to-xls"
                    filename="tablexls"
                    sheet="tablexls"
                    buttonText="Download as XLS"
                  />

                  <TableContainer dir="rtl">
                    <Table aria-label="sticky table">
                      <TableHead>
                        <TableRow>
                          <TableCell
                            key={"user_id"}
                            align={"center"}
                            style={{ minWidth: 30 }}
                            sortDirection={
                              orderBy === "user_id" ? order : false
                            }
                          >
                            {"آی دی کاربر"}
                            <TableSortLabel
                              active={orderBy === "user_id"}
                              direction={orderBy === "user_id" ? order : "asc"}
                              onClick={(e) => {
                                this.createSortHandler("user_id");
                              }}
                            ></TableSortLabel>
                          </TableCell>

                          <TableCell
                            key={"user_name"}
                            align={"center"}
                            style={{ minWidth: 60 }}
                          >
                            {"نام کاربر"}
                            <TableSortLabel
                              active={orderBy === "user_name"}
                              direction={
                                orderBy === "user_name" ? order : "asc"
                              }
                              onClick={(e) => {
                                this.createSortHandler("user_name");
                              }}
                            ></TableSortLabel>
                          </TableCell>

                          <TableCell
                            key={"user_mobile"}
                            align={"center"}
                            style={{ minWidth: 60 }}
                          >
                            {" همراه"}
                            <TableSortLabel
                              active={orderBy === "user_mobile"}
                              direction={
                                orderBy === "user_mobile" ? order : "asc"
                              }
                              onClick={(e) => {
                                this.createSortHandler("user_mobile");
                              }}
                            ></TableSortLabel>
                          </TableCell>

                          <TableCell
                            key={"organ_user_personal_code"}
                            align={"center"}
                            style={{ minWidth: 60 }}
                          >
                            {" کد پرسنلی"}
                            <TableSortLabel
                              active={orderBy === "organ_user_personal_code"}
                              direction={
                                orderBy === "organ_user_personal_code"
                                  ? order
                                  : "asc"
                              }
                              onClick={(e) => {
                                this.createSortHandler(
                                  "organ_user_personal_code"
                                );
                              }}
                            ></TableSortLabel>
                          </TableCell>

                          <TableCell
                            key={"user_national_code"}
                            align={"center"}
                            style={{ minWidth: 60 }}
                          >
                            {" کد ملی"}
                            <TableSortLabel
                              active={orderBy === "user_national_code"}
                              direction={
                                orderBy === "user_national_code" ? order : "asc"
                              }
                              onClick={(e) => {
                                this.createSortHandler("user_national_code");
                              }}
                            ></TableSortLabel>
                          </TableCell>

                          <TableCell
                            key={"request_check_sumnotpass"}
                            align={"center"}
                            style={{ minWidth: 60 }}
                          >
                            {"مبلغ بدهی "}
                            <TableSortLabel
                              active={orderBy === "request_check_sumnotpass"}
                              direction={
                                orderBy === "request_check_sumnotpass"
                                  ? order
                                  : "asc"
                              }
                              onClick={(e) => {
                                this.createSortHandler(
                                  "request_check_sumnotpass"
                                );
                              }}
                            ></TableSortLabel>
                          </TableCell>

                          <TableCell></TableCell>
                        </TableRow>
                      </TableHead>

                      <TableBody>
                        {requestinfofilter
                          .slice(
                            page * rowsPerPage,
                            page * rowsPerPage + rowsPerPage
                          )
                          .map((row) => {
                            return <Row key={row.name} row={row} self={this} />;
                          })}
                      </TableBody>
                    </Table>
                  </TableContainer>
                  <TablePagination
                    rowsPerPageOptions={[10, 25, 100]}
                    component="div"
                    count={requestinfofilter.length}
                    rowsPerPage={rowsPerPage}
                    page={page}
                    onChangePage={this.handleChangePage}
                    onChangeRowsPerPage={this.handleChangeRowsPerPage}
                  />
                </Paper>
                {this.state.openImageBox && (
                  <Lightbox
                    medium={urlToLargeImageFile}
                    large={urlToHugeImageFile}
                    alt={descImageFile}
                    onClose={this.closeLightbox}
                    showRotate={true}
                    hideZoom={false}
                  />
                )}
              </Container>
            </Grid>
          </Grid>

          {okstatus ? (
            <Alert severity="success">
              <AlertTitle>پیام</AlertTitle>
              {errstr}
            </Alert>
          ) : null}
        </div>
      );
    }
  }
}

function Row(props) {
  const { row, self } = props;
  console.log(row);
  const [open, setOpen] = React.useState(false);
  const classes = useRowStyles();
  var request_check_notpass;

  if (row["request_check_notpass"]) {
    request_check_notpass = row["request_check_notpass"];
  }

  return (
    <React.Fragment>
      <TableRow
        hover
        role="checkbox"
        tabIndex={-1}
        key={row["user_id"]}
        value={row}
      >
        <TableCell key={"user_id"} align={"center"}>
          {row["user_id"]}
        </TableCell>

        <TableCell key={"user_name"} align={"center"}>
          {row["user_name"] + " " + row["user_family"]}
        </TableCell>

        <TableCell key={"user_mobile"} align={"center"}>
          {row["user_mobile"]}
        </TableCell>

        <TableCell key={"organ_user_personal_code"} align={"center"}>
          {row["organ_user_personal_code"]}
        </TableCell>

        <TableCell key={"user_national_code"} align={"center"}>
          {row["user_national_code"]}
        </TableCell>

        <TableCell key={"request_check_sumnotpass"} align={"center"}>
          {
            <NumberFormat
              displayType={"text"}
              value={row["request_check_sumnotpass"]}
              thousandSeparator={true}
              prefix={" ریال"}
            />
          }
        </TableCell>

        <TableCell>
          <Checkbox
            checked={row["checked"]}
            onChange={(e) => {
              self.handleChangeCheckbox(e, row);
            }}
            size="medium"
            inputProps={{ "aria-label": "checkbox with small size" }}
          />
          <br />
          <IconButton
            aria-label="expand row"
            size="small"
            onClick={() => setOpen(!open)}
          >
            {open ? <KeyboardArrowUpIcon /> : <KeyboardArrowDownIcon />}
          </IconButton>
        </TableCell>
      </TableRow>

      <TableRow>
        <TableCell style={{ paddingBottom: 0, paddingTop: 0 }} colSpan={6}>
          <Collapse in={open} timeout="auto" unmountOnExit>
            <Table size="small" aria-label="purchases">
              <TableHead>
                <TableRow>
                  <TableCell>{"شماره سند"} </TableCell>
                  <TableCell>{"تاریخ تعهد"}</TableCell>
                  <TableCell>{"رشته"} </TableCell>
                  <TableCell>{" شرکت"}</TableCell>
                  <TableCell>{"شماره بیمه نامه"}</TableCell>
                  <TableCell>{"مبلغ"}</TableCell>
                  <TableCell></TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {request_check_notpass.map((request_check, index) => (
                  <TableRow>
                    <TableCell>
                      {request_check["instalment_check_id"]}
                    </TableCell>
                    <TableCell>
                      {new JDate(
                        new Date(
                          parseInt(
                            Moment(
                              request_check["instalment_check_date"],
                              "YYYY-M-D HH:mm:ss"
                            ).format("x")
                          )
                        )
                      ).format("YYYY/MM/DD") +
                        " " +
                        Moment(
                          request_check["instalment_check_date"],
                          "YYYY-M-D HH:mm:ss"
                        ).format("HH:mm:ss")}
                    </TableCell>
                    <TableCell>{request_check["fieldinsurance_fa"]}</TableCell>
                    <TableCell>{request_check["company_name"]}</TableCell>
                    <TableCell>
                      {request_check["requst_ready_num_ins"]}
                    </TableCell>

                    <TableCell>
                      {
                        <NumberFormat
                          displayType={"text"}
                          value={request_check["instalment_check_amount"]}
                          thousandSeparator={true}
                          prefix={" ریال"}
                        />
                      }
                    </TableCell>
                    <TableCell>
                      <Checkbox
                        checked={request_check["checked"]}
                        onChange={(e) => {
                          self.handleChangeCheckbox2(
                            e,
                            row,
                            request_check["instalment_check_id"]
                          );
                        }}
                        size="medium"
                        inputProps={{
                          "aria-label": "checkbox with small size",
                        }}
                      />
                    </TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </Collapse>
        </TableCell>
      </TableRow>
    </React.Fragment>
  );
}

export default withStyles(styles)(ChangeReportInstalmentDificitOrganSend);
